// initial state
const state = {
	isOnline: false,
	token: null,
	user: null,
	isTokenInvalid: false,		
	flag: false,
	nameTab:null,
	loginType: null
}

// 退出登录 / 踢下线时需清理的购物车、结算相关 session 缓存
const CHECKOUT_SESSION_KEYS = [
	'checkout_address_id', // 购物车/结算页当前选中的收货地址
	'cart_checkout_rec_ids', // 去结算时选中的商品 rec_id
	'cart_checkout_products', // 结算商品明细（红包等接口用）
	'cart_selected_rec_ids', // 购物车勾选状态（返回购物车时恢复）
	'cart_gift_select', // 结算用赠品选择参数
	'cart_gift_selection_map', // 购物车赠品勾选明细
	'cart_checkout_bonus', // 结算页选中的红包
	'cart_checkout_code_bonus', // 本单验证券码红包列表
	'cart_checkout_remark', // 结算页备注
	'cart_checkout_invoice', // 结算页发票选择与填写信息
	'cart_checkout_source', // 结算来源标识（如索莱贝 points_buy）
	'cart_checkout_back', // 结算页返回目标（如详情页立即购买）
]

const clearCheckoutSessionCache = () => {
	CHECKOUT_SESSION_KEYS.forEach((key) => {
		sessionStorage.removeItem(key)
	})
}

// mutations
const mutations = {
	signin(state, payload) {
		this.commit('saveUser', payload)
		this.commit('saveToken', payload)
		state.isTokenInvalid = false
	},
	signout(state) {
		clearCheckoutSessionCache()
		this.commit('clearUser')
		this.commit('clearToken')
		this.commit('clearLoginType')
		this.commit('unselectAddressItem')
		this.commit('clearEditingAddress')
		this.commit('setCartNumber', 0)
	},
	kickout(state) {
		clearCheckoutSessionCache()
		this.commit('clearUser')
		this.commit('clearToken')
		this.commit('clearLoginType')
		this.commit('unselectAddressItem')
		this.commit('clearEditingAddress')
		this.commit('setCartNumber', 0)
		state.isTokenInvalid = true
	},
	saveUser(state, payload) {
		state.user = Object.assign({}, payload.user)
	},
	saveToken(state, payload) {
		state.isOnline = true
		state.token = payload.token
	},
	clearUser(state) {
		state.user = null
	},
	clearToken(state) {
		state.isOnline = false
		state.token = null
	},
	changeFlag(state, value) {
		state.flag = value;
	},
	saveNameTab(state,value) {
		state.nameTab = value
	},
	saveLoginType(state, value) {
		state.loginType = value
	},
	clearLoginType(state) {
		state.loginType = null
	},
}

export default {
	// namespaced: true,
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js